import React, { FC } from 'react';
import { Language } from '@eta/components';
import { GetTaxpayerBranchDto } from '../../../Services/ClientProxy/clientProxy';
import './BranchSearchItem.scss';

export interface BranchSearchItemProps {
    BranchLine: GetTaxpayerBranchDto;
    currentLanguage: Language;
    align: 'Left' | 'Right';
}

export const BranchSearchItem: FC<BranchSearchItemProps> = (
    props: BranchSearchItemProps
) => {
    const { BranchLine, currentLanguage } = props;
    const en = !currentLanguage.isRtl;

    return (
        <>
            {BranchLine !== undefined && (
                <div className="branchSearchItem">
                    <div className="branchName">
                        <span className="BoldbranchNumber">
                            {BranchLine.branchNumber}
                        </span>
                        <span>
                            {` - ${
                                (en
                                    ? BranchLine.namePrimaryLang ??
                                      BranchLine.nameSecondaryLang
                                    : BranchLine.nameSecondaryLang) ??
                                BranchLine.sourceAddress
                            }`}
                        </span>
                    </div>
                    <div className="formattedAddress">
                        {en
                            ? BranchLine.address?.formattedAddressEn
                            : BranchLine.address?.formattedAddressAr}
                    </div>
                </div>
            )}
        </>
    );
};
